import React, { useEffect, useState } from 'react';
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout';
import { Button, Card, Dropdown, DropdownItem } from 'flowbite-react';
import walletIcon from '../../../assets/wallet.png';
import CustomTable from '../../../components/Table/CustomTable';
import usFlag from '../../../assets/United States of America (US).png';
import client from '../../../api/client';
import CustomModal from '../../../components/Modal/CustomModal';
import MakeTransferModal from './MakeTransferModal/MakeTransferModal';
import FundWalletModal from './FundWalletModal/FundWalletModal';
import { ColumnPayouts, PayoutsData, PayoutsDataNew } from '../../../types/TablesTypes/Payouts';
import moment, { Moment } from 'moment';
import showToast from '../../../components/CustomToast/toastHelper';
import { numberWithCommas } from '../../../utils/formatNumber';
import StatusView from '../../../components/StatusView/StatusView';
import { FaEllipsisH } from 'react-icons/fa';
import { useCurrency } from '../../../contexts/CurrencyContext';
import TransferDetails from './TransferDetails/TransferDetails';
import { RiSendPlane2Fill } from 'react-icons/ri';
import { BiPaperPlane } from 'react-icons/bi';
import logo from '../../../assets/Ideos.png'
interface AccountDetails {
  bankName: string | null;
  bankCode: string | null;
  accountName: string | null;
  accountNumber: string | null;
}

interface Balance {
  ledgerBalanceChange: number;
  availableBalanceChange: number;
  availableBalance: number;
  ledgerBalance: number;
  overdraftLimit: number;
  currencyShortName: string;
  currencyName: string;
  walletType: string | null;
  walletRestriction: string;
  totalTransfer: number;
  successfulTransfer: number;
  walletId: number;
  accountDetails: AccountDetails;
}

const Transfers = () => {
  const headings = ["Payout Date", "Recipient", "Account Number", "Total Amount", "Type", "Settle Amount", "Status", "Action"];

  const [balances, setBalances] = useState<any[]>([]);
  const [showTransferModal, setShowTransferModal] = useState<any>({
    isOpen: false,
    data: null
  });
  const [showFundModal, setShowFundModal] = useState({
    isOpen: false,
    data: null
  });
  const { availableCurrencies, currency } = useCurrency()
  // const [selectedOption, setSelectedOption] = useState(availableCurrencies[0]);
  const [payouts, setPayouts] = useState<any>()
  const [status, setStatus] = useState<string>("")
  const [tableRow, setTableRow] = useState<any[]>();
  const [loading, setLoading] = useState<boolean>(true);
  const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false)
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await fetchBalances();
      await fetchPayouts()
      setLoading(false)
    };
    fetchData();
  }, []);

  const filteredBalances = balances.filter(balance => balance.currencyShortName === currency);

  const availableBalance = filteredBalances.length > 0 ? filteredBalances[0].availableBalance : 0;
  const totalTransfer = filteredBalances.length > 0 ? filteredBalances[0].totalTransfer : 0;
  const successfulTransfer = filteredBalances.length > 0 ? filteredBalances[0].successfulTransfer : 0;
  const ngnBalance = balances.filter(balance => balance.currencyShortName === "NGN")

  const fetchBalances = async () => {
    try {
      const response = await client.get('/subsidiary/dashboard/get/wallet/balance');
      setBalances(response.data.wallets);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('error getting data', err);
      }
    }
  };


  const fetchPayouts = async () => {
    try {
      const apiUrl = `/subsidiary/payout/history`;
      // const params = new URLSearchParams(filters).toString();
      const response = await client.get(`${apiUrl}`);

      setPayouts(response.data.data);
      const message = response?.data?.message;

    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, "error");
      }
    }
  };

  const dataPayout = () => {
    const tempArr: PayoutsData[] = [];
    payouts?.items
      ?.slice(0)
      .forEach((payout: any, index: number) => {
        tempArr.push({
          dateInitiated: (moment.utc(payout?.dateInitiated).local() as Moment).format(
            'MMMM Do YYYY, h:mm a'
          ),
          recipientName: payout?.recipientName,
          accountNumber: payout?.accountNumber,
          type: payout?.type,
          transferType: payout?.transferType,
          currency: payout?.debitCurrency,
          amount: `${payout?.debitCurrency} ${numberWithCommas(
            payout?.amount
          )}`,
          fee: `${payout?.debitCurrency} ${numberWithCommas(payout?.fee)}`,
          status: (
            <StatusView
              status={payout?.status}
              green='Approved , Successful'
              red='Rejected ,Failed, Declined'
              orange='Processing ,Pending'
            />
          ),
          action: (
            <Dropdown label={
              <FaEllipsisH />
            } inline arrowIcon={false} placement='right-start'>
              <DropdownItem onClick={() => handleOpenDetailsModal(payout)}>View Details</DropdownItem>
            </Dropdown>
          ),
        });
      });
    return tempArr;
  };

  useEffect(() => {
    const fetch = async () => {
      setTableRow(dataPayout());
    }
    fetch()
  }, [payouts?.items]);

  const handleOpenDetailsModal = (transaction: any) => {
    setSelectedTransaction(transaction);
    setOpenDetailsModal(true);
  };

  return (
    <PrivateLayout>
      <div className='my-10 mx-6'>
        <div className='flex items-center gap-3'>
          <p className='font-semibold text-xl'>Transfers</p>
          {/* <div className='inline-block border py-3 px-6 rounded-full'>
            <Dropdown label={<span className='flex items-center gap-2'>
              <img src={selectedOption.flag} alt={`${selectedOption.currency} flag`} />
              <p>{selectedOption.currency}</p>
            </span>} inline arrowIcon className='rounded-xl'>
              <div className='w-48 px-3 py-4'>
                {availableCurrencies.map(currency => (
                  <Dropdown.Item key={currency.currency} onClick={() => setSelectedOption(currency)}>
                    <div className='inline-block text-md border py-3 px-4 rounded-full w-full'>
                      <span className='flex items-center gap-2'>
                        <img src={currency.flag} alt={`${currency.currency} flag`} />
                        <p>{currency.currency}</p>
                      </span>
                    </div>
                  </Dropdown.Item>
                ))}
              </div>
            </Dropdown>
          </div> */}
        </div>
        <div className='flex my-6'>
          <div className='flex items-center gap-3 mt-2 lg:mt-0 lg:ml-auto '>
            <Button className='bg-custom-button-green text-black hover:text-white' onClick={() => setShowTransferModal({ isOpen: true, data: null })}>
              <div className='flex items-center gap-1'>
                <BiPaperPlane size={20} />
                <span>Make transfer</span>
              </div>
            </Button>
            <Button className='rounded-md bg-green-800' onClick={() => setShowFundModal({ isOpen: currency == "NGN" ? true : false, data: ngnBalance[0] })}>
              <div className='flex gap-2 text-white'>
                <img src={walletIcon} alt="wallet icon" />
                <span>Fund Wallet</span>
              </div>
            </Button>
          </div>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 my-6'>
          <div>
            <Card>
              <p>Available Balance</p>
              <div className='flex gap-2 pb-10'>
                <p>{currency}</p>
                <p className='text-xl font-bold'>{numberWithCommas(availableBalance)}</p>
              </div>
            </Card>
          </div>
          <div>
            <Card>
              <p>Total Transfer</p>
              <div className='flex gap-2 pb-10'>
                <p>{currency}</p>
                <p className='text-xl font-bold'>{numberWithCommas(totalTransfer)}</p>
              </div>
            </Card>
          </div>
          <div>
            <Card>
              <p>Successful Transfer</p>
              <div className='flex gap-2 pb-10'>
                <p>{currency}</p>
                <p className='text-xl font-bold'>{numberWithCommas(successfulTransfer)}</p>
              </div>
            </Card>
          </div>
        </div>
        <div>
          <CustomTable data={tableRow ? tableRow : []} headings={ColumnPayouts} loading={loading} emptyMessage={`You have not made any transfers in ${currency}`} />
        </div>
        <CustomModal
          size="lg"
          icon=""
          dismissible={true}
          show={showTransferModal.isOpen || showFundModal.isOpen}
          onClose={() => {
            setShowTransferModal({ isOpen: false, data: null });
            setShowFundModal({ isOpen: false, data: null });
          }}
        >
          {showTransferModal.isOpen ? (
            <MakeTransferModal close={() => setShowTransferModal({ isOpen: false, data: null })} onSuccess={fetchPayouts} />
          ) : showFundModal.isOpen ? (
            <FundWalletModal data={showFundModal.data} />
          ) : null}
        </CustomModal>
        <CustomModal show={openDetailsModal} icon='' dismissible onClose={() => setOpenDetailsModal(false)} size='md'>
          <TransferDetails transaction={selectedTransaction} closeTransferDetailsModal={() => { setOpenDetailsModal(false) }} onSuccessfulVerification={fetchPayouts} />
        </CustomModal>
      </div>
      {loading && (
        <div className=" inset-0 z-50 flex items-center justify-center bg-white/70">
          <img src={logo} alt="Loading..." className="w-16 animate-spin" />
        </div>
      )}
    </PrivateLayout>
  );
}

export default Transfers;
